import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { AuthorizationCheck } from '../../utils/AuthorizationCheck';

const Resources = ({auth}) => {
    
    

    if ( AuthorizationCheck(auth) ) {
        return ( 
    
            <>
                {/*MOBILE*/}
                
    
                {/*DESKTOP*/}
                <div className="mt-5">      
                    <div className="row mx-0">                        
                        <div className="col-1"></div>
                        <div className="col-10">
                            <Row style={{ paddingTop: "20px", overflow:"hidden" }}>
                                <Col xs={12} >       
                                        
                                    <Row style={{ paddingTop: "20px", fontSize:"3em", lineHeight: "1em" }}>
                                        <Col>Resources</Col>
                                    </Row>     
                                    <div className="row" >
                                        <div className="col-12 mt-3">
                                            Welcome to our resources page. Here you'll find helpful information, tools, and links to support your needs. This page is designed to provide valuable resources for our users. If you have suggestions for additional resources, please submit a <Link to="/request" style={{color:"#000000AA"}}>request</Link>.
                                            <br /><br />
                                            All resources are organized by category for easy navigation.
                                        </div>
                                    </div>
                                    <Row>
                                        <div className="d-flex flex-wrap align-items-start mt-5">
                                            <div className="col-xl-4 col-12 p-1">
                                                <div className="card mb-4 box-shadow">
                                                    <div className="card-header">
                                                        <h4 className="my-0 font-weight-normal text-center">Getting Started</h4>
                                                    </div>
                                                    <div className="card-body">                  
                                                        <p className="text-left">
                                                            <span className="text-muted">
                                                                Essential resources to help you get started with our platform.                        
                                                            </span>
                                                            
                                                        </p>
                                                        <ul className="list-unstyled mt-3 mb-4 text-left" >
                                                            
                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Quick Start Guide</button><br />Learn the basics and get up and running quickly.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>User Manual</button><br />Comprehensive guide to all features and functionality.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Video Tutorials</button><br />Step-by-step video guides for common tasks.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>FAQ</button><br />Answers to frequently asked questions.</li>    

                                                            
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-4 col-12 p-1">
                                                <div className="card mb-4 box-shadow">
                                                    <div className="card-header">
                                                        <h4 className="my-0 font-weight-normal text-center">Advanced Features</h4>
                                                    </div>
                                                    <div className="card-body">
                                                    <p className="text-left">
                                                            <span className="text-muted">
                                                                Explore advanced features and capabilities to get the most out of our platform.                
                                                            </span>
                                                            
                                                        </p>
                                                        <ul className="list-unstyled mt-3 mb-4 text-left" >
                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>API Documentation</button><br />Technical documentation for developers and integrations.</li> 
                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Best Practices</button><br />Recommended approaches and optimization tips.</li>                             
                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Integration Guide</button><br />How to connect with other tools and services.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>  
                                            <div className="col-xl-4 col-12 p-1">
                                                <div className="card mb-4 box-shadow">
                                                    <div className="card-header">
                                                        <h4 className="my-0 font-weight-normal text-center">Support & Community</h4>
                                                    </div>
                                                    <div className="card-body">
                                                    <p className="text-left">
                                                            <span className="text-muted">
                                                                Generic support and community information goes here.             
                                                            </span>
                                                            
                                                        </p>
                                                        <ul className="list-unstyled mt-3 mb-4 text-left" >
                                                            
                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Help Center</button><br />Comprehensive help articles and troubleshooting guides.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Contact Support</button><br />Get in touch with our support team for personalized assistance.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Community Forum</button><br />Connect with other users and share tips and best practices.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Feature Requests</button><br />Submit ideas for new features and improvements.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Status Page</button><br />Check system status and maintenance updates.</li>
                                                            
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 p-1">
                                                <div className="card mb-4 box-shadow">
                                                    <div className="card-header">
                                                        <h4 className="my-0 font-weight-normal text-center">Templates & Examples</h4>
                                                    </div>
                                                    <div className="card-body">
                                                    <p className="text-left">
                                                            <span className="text-muted">
                                                                Ready-to-use templates and examples to help you get started quickly.           
                                                            </span>
                                                            
                                                        </p>
                                                        <ul className="list-unstyled mt-3 mb-4 text-left" >
                                                            
                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Template Library</button><br />Collection of customizable templates for common use cases.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Sample Projects</button><br />Example projects and implementations to learn from.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Code Examples</button><br />Code snippets and examples for developers.</li>
                                                            
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 p-1">
                                                <div className="card mb-4 box-shadow">
                                                    <div className="card-header">
                                                        <h4 className="my-0 font-weight-normal text-center">Training & Education</h4>
                                                    </div>
                                                    <div className="card-body">
                                                    <p className="text-left">
                                                            <span className="text-muted">
                                                                Educational resources and training materials to help you master our platform.
                                                            </span>
                                                            
                                                        </p>
                                                        <ul className="list-unstyled mt-3 mb-4 text-left" >
                                                            
                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Online Courses</button><br />Comprehensive training courses and certifications.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Webinars</button><br />Live and recorded webinars on advanced topics.</li>
                                                            
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-xl-4 col-12 p-1">
                                                <div className="card mb-4 box-shadow">
                                                    <div className="card-header">
                                                        <h4 className="my-0 font-weight-normal text-center">Tools & Integrations</h4>
                                                    </div>
                                                    <div className="card-body">
                                                    <p className="text-left">
                                                            <span className="text-muted">
                                                                Additional tools and integrations to enhance your workflow and productivity.
                                                            </span>
                                                            
                                                        </p>
                                                        <ul className="list-unstyled mt-3 mb-4 text-left" >
                                                            
                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Browser Extensions</button><br />Extensions to integrate our platform with your browser.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>Mobile Apps</button><br />Mobile applications for iOS and Android devices.</li>

                                                            <li className="pt-2"><button type="button" className="btn btn-link p-0" style={{color:"#000000CC", textDecoration:"none"}}>API Tools</button><br />Tools and utilities for working with our API.</li>
                                                            
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>                                            

                                        </div>
                                    </Row>                                    
                                </Col>                            
                            </Row>
                            
                        </div>    
                    </div>
                </div>
                
                
            </>
        ); 
    }
    else {
        return (<>Please wait</>);
    }               
        
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Resources);
